import callApi, { CallApiResult, getCustomerId } from 'src/api';
import ApplianceAboRequest from 'src/components/account/my-services/ApplianceAboRequest';
import { SCHEMA_CUSTOMER_COMPLAINT_SHAPE, SCHEMA_CUSTOMER_HAND_ON_SHAPE } from 'src/schemas/CustomerService';

export const fetchCustomerAppliances = (): Promise<CallApiResult> => {
    const customerId = getCustomerId();
    const endpoint = '/api/customer/' + customerId + '/appliances';

    return callApi(endpoint);
};

export const fetchCustomerApplianceCommonBugs = (applianceId: string): Promise<CallApiResult> => {
    const customerId = getCustomerId();
    const endpoint = `/api/customer/${customerId}/appliances/${applianceId}/commonBugs`;

    return callApi(endpoint);
};

export const handOnCustomerAppliance = (data: SCHEMA_CUSTOMER_HAND_ON_SHAPE, applianceId: string) => {
    const customerId = getCustomerId();
    const endpoint = `/api/customer/${customerId}/appliances/${applianceId}/handOn`;
    return callApi(endpoint, { method: 'POST', data: data.customerId });
};

export const cancelHandOnCustomerAppliance = (applianceId: string) => {
    const customerId = getCustomerId();
    const endpoint = `/api/customer/${customerId}/appliances/${applianceId}/handOn`;
    return callApi(endpoint, { method: 'DELETE' });
};

export const acceptHandOnCustomerAppliance = (applianceId: string) => {
    const customerId = getCustomerId();
    const endpoint = `/api/customer/${customerId}/appliances/${applianceId}/approveRetrieval`;
    return callApi(endpoint, { method: 'POST' });
};

export const rejectHandOnCustomerAppliance = (applianceId: string) => {
    const customerId = getCustomerId();
    const endpoint = `/api/customer/${customerId}/appliances/${applianceId}/rejectRetrieval`;
    return callApi(endpoint, { method: 'POST' });
};

export const createComplaintForCustomerAppliance = (data: SCHEMA_CUSTOMER_COMPLAINT_SHAPE) => {
    const customerId = getCustomerId();
    const endpoint = `/api/customer/${customerId}/appliances/${data.applianceId}/complaint`;
    return callApi(endpoint, { method: 'POST', data });
};

export const fetchFixedRatePriceForCustomerAppliance = (applianceId: string) => {
    const customerId = getCustomerId();
    const endpoint = `/api/customer/${customerId}/appliances/${applianceId}/fixedRate`;
    return callApi(endpoint, { method: 'GET' });
};

/** R69 item 5b: the service package (Abo-Vorlage) the shop sells for an own machine. */
export interface ServicePackageOffer {
    available: boolean;
    templateNumber?: number;
    templateName?: string;
    productNumber?: number;
    vendorId?: number;
    nettPrice?: number;
    grossPrice?: number;
    intervalMonths?: number;
    minTermMonths?: number;
    noticePeriodMonths?: number;
    ageInMonths?: number;
    ageFeeNett?: number;
    ageFeeGross?: number;
}

export const fetchServicePackageOffer = (applianceId: string): Promise<CallApiResult<ServicePackageOffer>> =>
    callApi('/api/ordering/v2/my/servicePackageOffer', { params: { applianceId } });

export const fetchCustomerComplaints = (): Promise<CallApiResult> => {
    const customerId = getCustomerId();
    const endpoint = '/api/customer/' + customerId + '/complaints';

    return callApi(endpoint);
};

export const returnAppliance = (returnedApplianceId: string, applianceAboRequest: ApplianceAboRequest) => {
    const customerId = getCustomerId();
    const endPoint = `/api/customer/${customerId}/appliances/${returnedApplianceId}/returned`;
    return callApi(endPoint, { method: 'POST', data: applianceAboRequest });
};
